import { Middleware } from "redux"
import { RootState } from "../store"
import * as signalR from "@microsoft/signalr";
import { identity, sessionSlice } from "../store/sessionSlice";

export const REALTIME_MONITOR = 'realtime/monitor';

// Define the action creator
export const monitorOperation = (context: string) => ({
  type: REALTIME_MONITOR,
  payload: context,
});

export const realtimeMiddleware = (url: string): Middleware<
  {}, // Most middleware do not modify the dispatch return value
  RootState
> => {
  let connection: signalR.HubConnection;

  const connect = async () => {
    if (connection === undefined) {
      connection = new signalR.HubConnectionBuilder()
        .withUrl(url)
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Trace)
        .build();
    }
    try {
      await connection.start();
    }
    catch (err) {
      console.error("Realtime error: ", err)
    }
    //.catch(err => console.error("Realtime error: ", err));

  };

  return storeApi => next => action => {
    const state = storeApi.getState() // correctly typed as RootState
    console.log('realtimeMiddleware', action);
    switch (action.type) {
      case REALTIME_MONITOR:
        console.log('Subscribing to realtime', action);
        connect().then(() => {
          if (connection.state === signalR.HubConnectionState.Connected) {
            connection.invoke('monitor', action.payload)
              .catch(err => console.error('SignalR monitor Error: ', err));
          }
          else {
            console.error("Unable to subscribe to realtime operation as SignaR is currently ", connection.state);
          }
        });
        break;
      case 'session/identity/fulfilled':
        connect().then(() => {
          connection.on("dispatch", (type, action) => {
            console.log('onDispatch', type, action);
            storeApi.dispatch({
              type,
              payload: action,
            });
          });
          connection.on("message", (operation) => {
            console.log('onMessage', operation);
            storeApi.dispatch(sessionSlice.actions.operationMessage(operation));
          });
          connection.on("complete", (operation) => {
            console.log('onComplete', operation);
            storeApi.dispatch(sessionSlice.actions.operationMessage(operation));
          });
        })
        break;
    }
    return next(action);
  }
} 
